import { ReactComponent as Schedule } from 'assets/icons/icon-schedule.svg';

export default Schedule;
